import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface SidebarPaginationProps {
  currentPage: number;
  totalPages?: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
  isPreviousDisabled?: boolean;
  isNextDisabled?: boolean;
}

interface SidebarContainerProps {
  children: ReactNode;
  pagination?: SidebarPaginationProps;
  className?: string;
  contentClassName?: string;
}

export function SidebarContainer({
  children,
  pagination,
  className,
  contentClassName,
}: SidebarContainerProps) {
  return (
    <div className={cn('w-full h-full max-h-[calc(100vh-120px)] bg-white flex flex-col', className)}>
      <div className={cn('flex-1 overflow-y-auto', contentClassName)}>
        {children}
      </div>

      {pagination && (
        <div className="border-t bg-white px-4 py-3 flex items-center justify-center">
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={pagination.onPreviousPage}
              disabled={pagination.isPreviousDisabled ?? pagination.currentPage === 1}
            >
              Previous
            </Button>
            <div className="text-sm font-medium text-gray-900 whitespace-nowrap min-w-[80px] text-center">
              {pagination.totalPages !== undefined
                ? `Page ${pagination.currentPage} of ${pagination.totalPages}`
                : `Page ${pagination.currentPage}`}
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={pagination.onNextPage}
              disabled={pagination.isNextDisabled ?? false}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
